exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fingering-container {\n    margin-top: 1em;\n    margin-bottom: 0.5em;\n    width: 100%;\n    text-align: center;\n    font-family: mononoki, monospace;\n    font-size: 2.5em;\n}\n\n.fingering-container-placeholder {\n    margin-top: 0em;\n    margin-bottom: 0.3em;\n    width: 100%;\n    text-align: center;\n    font-family: mononoki, monospace;\n    font-size: 2.5em;\n}\n\n.freq {\n    font-weight: bold;\n}\n\n.c0 {\n}\n", ""]);

// exports
